/// <amd-module name="Build/Shared/Components/DetailsSection/DetailsSection" />
import * as React from "react";

import { IDetailsSectionProps } from './DetailsSection.types';

import { Button } from "VSSUI/Button";
import { css } from "VSSUI/Util";

export interface IDetailsSectionState {
    isExpanded: boolean;
}

export class DetailsSection extends React.PureComponent<IDetailsSectionProps, IDetailsSectionState> {
    constructor(props: IDetailsSectionProps) {
        super(props);
        this.state = {
            isExpanded: props.isExpandedByDefault || false
        };
    }

    public render() {
        const detailsSectionId = this.props.sectionKey + "-details";
        const headerSectionId = this.props.sectionKey + "-header";
        const headerElement = this._getHeader();
        let showChevron = true;
        if (this.props.chevronProps) {
            showChevron = !this.props.chevronProps.hide;
        }

        return <div
            className={css("build-shared-details-section", "flex", "flex-column", "flex-grow ", this.props.className)}
            role="tabpanel">
            <div
                className="summary-primary-section flex">
                {
                    headerElement && React.cloneElement(headerElement, {
                        ...headerElement.props,
                        id: headerSectionId
                    })
                }
                {
                    showChevron && (
                        <Button
                            subtle={true}
                            iconProps={{
                                iconName: this.state.isExpanded ? "ChevronUp" : "ChevronDown",
                                style: {
                                    fontSize: "12px"
                                }
                            }}
                            className="chevron-area"
                            aria-controls={detailsSectionId}
                            {...this.props.chevronProps ?
                                {
                                    ariaLabel: this.props.chevronProps.ariaLabel
                                } : {}}
                            aria-expanded={this.state.isExpanded}
                            onClick={this._onToggleExpand}
                        />
                    )
                }
            </div>
            {
                this._getSubHeader()
            }
            <div
                className={css("details-section", !this.state.isExpanded && "details-hidden")}
                id={detailsSectionId}
                aria-labelledby={headerSectionId}>
                {
                    this._getContent()
                }
            </div>
        </div>;
    }

    public componentWillReceiveProps(nextProps: IDetailsSectionProps) {
        if (this.props.isExpandedByDefault !== nextProps.isExpandedByDefault) {
            this.setState({
                isExpanded: !!nextProps.isExpandedByDefault
            });
        }
    }

    private _onToggleExpand = () => {
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    }

    private _getHeader(): React.ReactElement<HTMLElement> | null {
        let header: React.ReactElement<HTMLElement> | null = null;
        React.Children.map(this.props.children as React.ReactChild[], (child) => {
            if (typeof child === "object" && child != null && child.type === DetailsSectionHeader) {
                header = child;
            }
        });

        return header;
    }

    private _getSubHeader(): React.ReactElement<HTMLElement> | null {
        let subHeader: React.ReactElement<HTMLElement> | null = null;
        React.Children.map(this.props.children as React.ReactChild[], (child) => {
            if (typeof child === "object" && child != null && child.type === DetailsSectionSecondaryHeader) {
                subHeader = child;
            }
        });

        return subHeader;
    }

    private _getContent(): React.ReactElement<HTMLElement> | null {
        let content: React.ReactElement<HTMLElement> | null = null;
        React.Children.map(this.props.children as React.ReactChild[], (child) => {
            if (typeof child === "object" && child != null && child.type === DetailsSectionContent) {
                content = child;
            }
        });

        return content;
    }
}

export class DetailsSectionContent extends React.Component<{}, {}> {
    public render() {
        return <div
            className="content">
            {React.Children.only(this.props.children)}
        </div>;
    }
}

export interface IDetailsSectionHeaderProps {
    renderAsHeading?: boolean;
}

export class DetailsSectionHeader extends React.Component<IDetailsSectionHeaderProps, {}> {
    public render() {
        // Id is set by us, don't expose it through props, if consumer really wants to set id
        // we can change our prop to something else and add both, for now, just use "id"
        if (this.props.renderAsHeading) {
            return <h3
                className="header-text ci-hover-behavior"
                id={(this.props as any).id}>
                {React.Children.only(this.props.children)}
            </h3>;
        }
        else {
            return <div
                id={(this.props as any).id}>{">"}
                {React.Children.only(this.props.children)}
            </div>;
        }
    }
}

export class DetailsSectionSecondaryHeader extends React.Component<{}, {}> {
    public render() {
        return <div
            className="summary-secondary-text">
            {React.Children.only(this.props.children)}
        </div>;
    }
}
